class FileTreeConfig {
  static getFileConfig = (id, name, parentData = "", can_delete = true, can_edit = true, fileInfo = {}, type = "") => {
    return {
      id: id,
      name: name,
      parentData: parentData,
      isFolder: false,
      items: [],
      can_delete: can_delete,
      can_edit: can_edit,
      fileInfo: fileInfo,
      type: type
    };
  };
  static getFolderConfig = (
    id,
    name,
    parentData,
    can_delete = true,
    can_insert = true,
    isOpen = true,
    insert_type = "inline",
    class_name = "",
    disabled = false,
    folderInfo = {}
  ) => {
    return {
      id: id,
      name: name,
      parentData: parentData,
      isFolder: true,
      items: [],
      can_delete: can_delete,
      can_insert: can_insert,
      isOpen: isOpen,
      insert_type: insert_type,
      class_name: class_name,
      disabled: disabled,
      folderInfo: folderInfo
    };
  };
}

export default FileTreeConfig;
